import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { createMask } from '@ngneat/input-mask';
import { AuctionService } from '@services/auction/auction.service';
import { InventoryService } from '@services/inventory/inventory.service';
import { environment } from 'environments/environment';
import { ViewerModalComponent } from 'ngx-ionic-image-viewer';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import {
  auctionPriceCheck,
  convertDateFormat,
  dateAndTimeConverter,
  daysDiff,
  sameDay,
  timesDiff,
} from '../../helpers/utils';

@Component({
  selector: 'app-timed-individual-auction-details',
  templateUrl: './timed-individual-auction-details.component.html',
  styleUrls: ['./timed-individual-auction-details.component.scss'],
})
export class TimedIndividualAuctionDetailsComponent implements OnInit {
  @Input() activeQuery:
    | 'timed-individual'
    | 'individual'
    | 'bulk'
    | 'individual-batch'
    | null;
  @Input() entityType: string;
  @Input() loading: boolean;

  public timedAuctionForm: FormGroup = null;
  public timedIndividualSubmitted: boolean = false;
  public laddaLoading: boolean = false;
  public endAuctionLoading: boolean = false;

  // ==================================================

  public productId: string = '';
  public auctionExists: boolean = false;
  public minDate: Date;
  public maxDate: Date;
  public individualBulkAuctionForm: FormGroup;
  public individualSubmitted: boolean = false;
  public bulkSubmitted: boolean = false;
  public allProductList: any;
  public batches: object[] = [];
  public auctionStartTime: any;
  public auctionEndTime: any;
  public live_auctionStartTime: any;
  public live_auctionEndTime: any;
  public bulk_auctionStartTime: any;
  public bulk_auctionEndTime: any;
  public otherDetailsList: any[] = [];
  public getOtherFieldIndicater: any;
  public live_auction_start: any;
  public live_auction_end: any;
  public bulkliveAuctionEndDate: any;
  public getProductImages: any[] = [];
  public getBatchImages: any[] = [];
  public openBulkAuctionField: boolean = false;
  public getBatchImagesForIndividual: any[] = [];
  public auctionBulkAdd: any[] = [];
  public BatchId: any;
  public bulkliveAuctionStartDate: any;
  public bulkAuctionStartDate: any;
  public bulkAuctionEndDate: any;
  public getBiddinfTimeInterval: any;
  public getCountdownTimer: any;
  public getBulkBiddinfTimeInterval: any;
  public getBulkCountdownTimer: any;
  public batchBulkImage: any;
  public selectedItems: object[] = [];
  public allIndividualProductList: any[] = [];
  public auctionFormData: any[] = [];
  public bulkItems: any[] = [];
  public bulkInfoList: any[] = [];
  public getBulkItemList: any[] = [];
  public getBulkItemsId: any[] = [];
  public baseUrl: string = environment.imgBaseUrl;

  public auctionType: 'timed-individual' | null;
  public auctionId: string = '';
  public adminApprove: boolean = false;
  public lockStatus: boolean;
  public bulkAdminApprove: boolean;
  public bulkLockStatus: boolean;
  public isThereNextPageOfAuctionVehicles: number;
  public ngSelectLoading: boolean;
  public initialVehicleList: object[] = [];
  public notFoundText: string =
    'No vehicle found; try to search by VIN number.';
  public currencyInputMask = createMask({
    alias: 'numeric',
    groupSeparator: ',',
    placeholder: '0',
    parser: (value: any) => {
      const parsedValue = value.replaceAll(',', '');
      return parsedValue;
    },
  });
  public batchMinimumSellingPrice: number = 0;
  public editId: string = '';
  public subscription = new Subscription();
  public batch = {
    page: 1,
    limit: 20,
    loading: false,
  };

  // =================================

  public invalidIndividualOpeningPrice: boolean = false;
  public invalidIndividualLowestPriceToAccept: boolean = false;
  public invalidIndividualIncrementalValue: boolean = false;
  public invalidIndividualBuyNowPrice2: boolean = false;
  public invalidIndividualBuyNowPrice3: boolean = false;

  public invalidCommonCountdownTimer: boolean = false;
  public invalidCommonBiddingTime: boolean = false;

  public invalidBulkOpeningPrice: boolean = false;
  public invalidBulkLowestPriceToAccept: boolean = false;
  public invalidBulkIncrementalValue: boolean = false;
  public invalidBulkBuyNowPrice2: boolean = false;
  public invalidBulkBuyNowPrice3: boolean = false;
  public isActiveAuction: boolean = false;

  // ==================================================

  private searchInputSubject = new Subject<{ items: any[]; term: string }>();

  constructor(
    public formBuilder: FormBuilder,
    public auctionService: AuctionService,
    public toastr: ToastrService,
    public router: Router,
    public inventoryService: InventoryService,
    public activeRoute: ActivatedRoute,
    private modalController: ModalController
  ) {
    const query = this.activeRoute.snapshot.queryParams['type'];
    const auctionType = this.activeRoute.snapshot.queryParams['auctionType'];
    const auctionId = this.activeRoute.snapshot.paramMap.get('auctionId');

    if (auctionId) {
      this.auctionId = auctionId;
    }
    if (query) {
      this.activeQuery = query;
    }
    if (auctionType) {
      this.auctionType = auctionType;
    }

    this.timedAuctionForm = this.formBuilder.group({
      title: ['', [Validators.required]],
      item1: [null],
      item2: [null],

      auction_start_date: ['', [Validators.required]], //
      auction_start_time: ['', [Validators.required]], //
      auction_end_date: ['', [Validators.required]], //
      auction_end_time: ['', [Validators.required]], //
      auction_start_date_time: ['', [Validators.required]], //
      auction_end_date_time: ['', [Validators.required]], //

      description: ['', [Validators.required]],

      live_auction_start_date: [
        { value: '', disabled: true },
        [Validators.required],
      ],
      live_auction_start_time: [
        { value: '', disabled: true },
        [Validators.required],
      ],
      live_auction_end_date: ['', [Validators.required]],
      live_auction_end_time: ['', [Validators.required]],

      opening_price: ['', [Validators.required]],
      lowest_price_to_accept: ['', [Validators.required]],
      incremental_value: ['', [Validators.required]],
      buy_now_price: ['', [Validators.required]],
      // time_interval: ['', [Validators.required, Validators.min(10)]],
      // countdown_timer: ['', [Validators.required, Validators.min(10)]],
      // time_interval: [''],
      // countdown_timer: [''],
      fields: this.formBuilder.array([]),
    });

    this.timedAuctionForm
      .get('auction_end_date')
      .valueChanges.subscribe((endDate) => {
        this.timedAuctionForm.patchValue({
          live_auction_start_date: endDate,
        });
      });

    this.timedAuctionForm
      .get('auction_end_time')
      .valueChanges.subscribe((endTime) => {
        this.timedAuctionForm.patchValue({
          live_auction_start_time: endTime,
        });
      });

    this.individualBulkAuctionForm = this.formBuilder.group({
      auctionDetails: this.formBuilder.array([]),
    });

    this.searchInputSubject.pipe(debounceTime(2000)).subscribe((event) => {
      this.onSearch(event);
    });
  }

  ngOnInit(): void {
    this.getAllBatchList();
    this.getAllListedproducts(1);
    if (this.auctionId) {
      this.getEditAuctionInfo();

      this.timedAuctionForm.controls['item1'].disable();
      this.timedAuctionForm.controls['item2'].disable();
    }
  }

  // =================================

  get timeIndividualFormArray() {
    return this.timedAuctionForm.get('fields') as FormArray;
  }

  // ==================================

  get newFields(): FormGroup {
    return this.formBuilder.group({
      entity_name: [''],
      entity_value: [''],
    });
  }

  // =================================

  async openViewer(imageURL: string) {
    const modal = await this.modalController.create({
      component: ViewerModalComponent,
      componentProps: {
        src: imageURL,
        scheme: 'dark',
      },
      cssClass: 'ion-img-viewer modal-popup modal-popup-container',
      keyboardClose: true,
      showBackdrop: true,
    });

    return await modal.present();
  }

  // ==================================

  addFields() {
    this.timeIndividualFormArray.push(this.newFields);
  }

  // ====================================

  removeFields(index: number) {
    this.timeIndividualFormArray.removeAt(index);
  }

  //================================

  runValidator(event: KeyboardEvent) {
    switch (event.target['name']) {
      case 'opening_price':
        {
          const openingPrice = parseInt(
            this.timedAuctionForm.get('opening_price').value
          );
          if (openingPrice < 1) {
            this.invalidIndividualOpeningPrice = true;
          } else {
            this.invalidIndividualOpeningPrice = false;
          }
        }
        break;

      case 'lowest_price_to_accept':
        {
          const openingPrice = parseInt(
            this.timedAuctionForm.get('opening_price').value
          );
          const lowestPriceToAccept = parseInt(
            this.timedAuctionForm.get('lowest_price_to_accept').value
          );

          if (lowestPriceToAccept < openingPrice) {
            this.invalidIndividualLowestPriceToAccept = true;
          } else {
            this.invalidIndividualLowestPriceToAccept = false;
          }
        }
        break;

      case 'incremental_value':
        {
          const incrementalValue = parseInt(
            this.timedAuctionForm.get('incremental_value').value
          );
          if (incrementalValue < 1) {
            this.invalidIndividualIncrementalValue = true;
          } else {
            this.invalidIndividualIncrementalValue = false;
          }
        }
        break;

      case 'buy_now_price':
        {
          const buyNowPrice = parseInt(
            this.timedAuctionForm.get('buy_now_price').value
          );
          const incrementalValue = parseInt(
            this.timedAuctionForm.get('incremental_value').value
          );
          const lowestPriceToAccept = parseInt(
            this.timedAuctionForm.get('lowest_price_to_accept').value
          );

          if (incrementalValue > buyNowPrice) {
            this.invalidIndividualBuyNowPrice2 = true;
          } else {
            this.invalidIndividualBuyNowPrice2 = false;
          }

          if (lowestPriceToAccept > buyNowPrice) {
            this.invalidIndividualBuyNowPrice3 = true;
          } else {
            this.invalidIndividualBuyNowPrice3 = false;
          }
        }
        break;

      // case 'time_interval':
      //   {
      //     let biddingInterval;

      //     biddingInterval = parseInt(
      //       this.timedAuctionForm.get('time_interval').value
      //     );

      //     if (biddingInterval >= 80) {
      //       this.invalidCommonBiddingTime = false;
      //     } else {
      //       this.invalidCommonBiddingTime = true;
      //     }
      //   }
      //   break;

      // case 'countdown_timer':
      // {
      //   let biddingInterval;
      //   let countdownTimer;

      //   biddingInterval = parseInt(
      //     this.timedAuctionForm.get('time_interval').value
      //   );
      //   countdownTimer = parseInt(
      //     this.timedAuctionForm.get('countdown_timer').value
      //   );

      //   if (
      //     countdownTimer > biddingInterval ||
      //     countdownTimer === 0 ||
      //     countdownTimer < 30
      //   ) {
      //     this.invalidCommonCountdownTimer = true;
      //   } else {
      //     this.invalidCommonCountdownTimer = false;
      //   }
      // }
      // break;
    }
  }

  // ===================================

  getAllListedproducts(page: number) {
    if (page === 1) {
      this.loading = true;
    } else if (page > 1) {
      this.ngSelectLoading = true;
    }

    this.inventoryService.getAllAuctionVehicle(1, 0, page).subscribe(
      (res) => {
        let data = res['data'];
        if (Array.isArray(data)) {
          res['data'].forEach((item) => {
            const data = item['description_data'];
            if (item['description_data']?.['VIN Number']) {
              this.allIndividualProductList.push({
                ...item,
                name: `${data['Model Year']} ${data['Model']} ${data['Interior Colour']} (${data['VIN Number']})`,
              });
            }
          });
          this.allIndividualProductList = this.allIndividualProductList.sort(
            (a, b) => a.name.localeCompare(b.name)
          );

          this.initialVehicleList = this.allIndividualProductList;
        }
        this.loading = false;
        this.ngSelectLoading = false;

        this.isThereNextPageOfAuctionVehicles = res?.['nextPage'];
      },
      (error: HttpErrorResponse) => {
        if (error.error.message == 'The incoming token has expired') {
          this.router.navigate(['/']);
        }
      }
    );
  }

  //=====================================

  get TimeIndividualControl() {
    return this.timedAuctionForm.controls;
  }

  // =======================================

  get individualBukFormArray() {
    return this.individualBulkAuctionForm.get('auctionDetails') as FormArray;
  }

  // =========================================

  get IndividualBulkFields(): FormGroup {
    return this.formBuilder.group({
      openingPrice: [''],
      lowestPriceToAccept: [''],
      incrementalValue: [''],
      buyNowPrice: [''],
      itemId: [''],
    });
  }

  // =====================================
  fetchNextPage() {
    if (!this.isThereNextPageOfAuctionVehicles) {
      return;
    }

    this.getAllListedproducts(this.isThereNextPageOfAuctionVehicles);
  }

  // ========================================

  onSearchInput(event: { items: any[]; term: string }) {
    if (!event.term) {
      this.allIndividualProductList = this.initialVehicleList;
      return;
    }

    this.searchInputSubject.next(event);
  }

  // ========================================

  onSearch(event: { items: any[]; term: string }) {
    if (event.items.length > 0) {
      return;
    }

    this.ngSelectLoading = true;

    this.inventoryService
      .filterProduct({ 'VIN Number': event.term.trim() })
      .subscribe((res) => {
        if (res?.['data']?.length) {
          this.allIndividualProductList = [];

          res['data'].forEach((item) => {
            const data = item['description_data'];
            if (item['description_data']?.['VIN Number']) {
              this.allIndividualProductList.push({
                ...item,
                name: `${data['Model Year']} ${data['Model']} ${data['Interior Colour']} (${data['VIN Number']})`,
              });
            }
          });
          this.allIndividualProductList = this.allIndividualProductList.sort(
            (a, b) => a.name.localeCompare(b.name)
          );
        } else {
          this.notFoundText = 'No vehicle found';
        }

        this.ngSelectLoading = false;
      });
  }

  // =========================================

  editAuctionService(data, type) {
    if (this.editId || this.bulkItems?.length) {
      data = {
        ...data,
        item: type === 'individual' ? this.editId : this.bulkItems,
        auction_time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
    } else {
      data = {
        ...data,
        auction_time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
    }

    const payload = {
      ...data,
      entity_type: this.activeQuery,
      item: this.productId,

      // live_auction_start_date_time: new Date(
      //   data?.live_auction_start_date_time
      // ).toISOString(),
    };

    // delete payload.live_auction_start;
    // delete payload.live_auctionStartTime;
    // delete payload.auction_start_date_time;
    // delete payload.auction_end_date_time;
    // delete payload.live_auction_start_date_time;

    return this.auctionService.editAuction(payload).subscribe(
      (res) => {
        this.toastr.success(res['message']);
        this.router.navigate([`dashboard/auction/timed-individual`], {
          queryParams: {
            tab: 'inventory',
            page: 1,
            limit: 10,
          },
        });
      },
      (error: HttpErrorResponse) => {
        this.laddaLoading = false;
        console.log(error);
      }
    );
  }

  // ====================================

  getProductInfo(event: string, value) {
    // Set value null when tab changes

    this.timedAuctionForm.get('item2').setValue('');
    this.timedAuctionForm.get('auction_start_date').setValue('');
    this.timedAuctionForm.get('auction_start_time').setValue('');
    this.timedAuctionForm.get('auction_end_date').setValue('');
    this.timedAuctionForm.get('auction_end_time').setValue('');
    this.timedAuctionForm.get('live_auction_start_date').setValue('');
    this.timedAuctionForm.get('live_auction_start_time').setValue('');
    this.timedAuctionForm.get('live_auction_end_date').setValue('');
    this.timedAuctionForm.get('live_auction_end_time').setValue('');
    this.timedAuctionForm.get('description').setValue('');

    //END

    this.openBulkAuctionField = value;
    this.getProductImages = [];
    this.inventoryService.getvehicleInfo(event).subscribe(
      (res) => {
        let data = res['data'];
        let description = data['description_data']['description'];
        this.timedAuctionForm.get('description').setValue(description);
        if (data['imageUrl'] && !data['vehicle_images']) {
          for (let [_, images] of Object.entries(data['imageUrl'])) {
            this.getProductImages.push(images['presigned_url']);
          }
        } else if (data['vehicle_images']) {
          for (let [_, images] of Object.entries(
            data['vehicle_images']['parts_images']
          )) {
            this.getProductImages.push(this.baseUrl + images['image']);
          }
        }
      },
      (error: HttpErrorResponse) => {
        if (error.error.message == 'The incoming token has expired') {
          this.router.navigate(['/']);
        }
      }
    );
  }

  // ====================================

  getbatchInfoForIndividual(event: string, value: any, type: string) {
    this.entityType = type;
    this.timedAuctionForm.get('item1').setValue('');
    this.timedAuctionForm.get('auction_start_date').setValue('');
    this.timedAuctionForm.get('auction_start_time').setValue('');
    this.timedAuctionForm.get('auction_end_date').setValue('');
    this.timedAuctionForm.get('auction_end_time').setValue('');
    this.timedAuctionForm.get('live_auction_start_date').setValue('');
    this.timedAuctionForm.get('live_auction_start_time').setValue('');
    this.timedAuctionForm.get('live_auction_end_date').setValue('');
    this.timedAuctionForm.get('live_auction_end_time').setValue('');
    this.timedAuctionForm.get('description').setValue('');
    // this.timedAuctionForm.get('time_interval').setValue('');
    // this.timedAuctionForm.get('countdown_timer').setValue('');

    this.openBulkAuctionField = value;
    this.getBatchImagesForIndividual = [];
    this.individualBukFormArray.clear();
    this.BatchId = event;
    this.inventoryService.getBatchView(this.BatchId).subscribe(
      (res) => {
        this.timedAuctionForm
          .get('description')
          .setValue(res?.['data']?.[0]?.['description']);
        res['data'].shift();

        for (let [_, product] of Object.entries(res['data'])) {
          if (product['auction_id']) {
            this.individualBukFormArray.clear();
            this.toastr.warning('Auction already exists!');
            this.auctionExists = true;
            break;
          } else {
            this.auctionExists = false;
            this.individualBukFormArray.push(this.IndividualBulkFields);
            this.getBatchImagesForIndividual.push(product);
          }
        }
      },
      (error: HttpErrorResponse) => {
        this.laddaLoading = false;
      }
    );
  }

  // ========================================

  saveTimedIndividualAuction(data: string) {
    this.timedIndividualSubmitted = true;

    if (this.entityType === 'individual_batch') {
      this.timedAuctionForm.controls['opening_price'].setErrors(null);
      this.timedAuctionForm.controls['lowest_price_to_accept'].setErrors(null);
      this.timedAuctionForm.controls['incremental_value'].setErrors(null);
      this.timedAuctionForm.controls['buy_now_price'].setErrors(null);
    }

    if (
      this.timedAuctionForm.invalid ||
      (!this.timedAuctionForm.controls['item1'].value &&
        !this.timedAuctionForm.controls['item2'].value)
    ) {
      this.toastr.error('Invalid Form');
    } else {
      // this.auctionType?

      this.addAuction(this.timedAuctionForm.value, data);
    }
  }

  // ==========================================

  addAuction(data: any, entityType: any) {
    this.laddaLoading = true;

    this.auctionStartTime = [];
    this.auctionEndTime = [];
    this.live_auctionEndTime = [];

    if (data && entityType && !this.auctionId) {
      // const auctionStartDate = data['auction_start_date'];
      // const auctionEndDate = data['auction_end_date'];

      // const auctionStartTime = data['auction_start_time'];
      // const auctionEndTime = data['auction_end_time'];

      // this.auctionStartTime = dateAndTimeConverter(
      //   auctionStartDate,
      //   auctionStartTime
      // );
      // this.auctionEndTime = dateAndTimeConverter(
      //   auctionEndDate,
      //   auctionEndTime
      // );

      // const auctionDayDiff = daysDiff(auctionStartDate, auctionEndDate);
      // const isAuctionSameDay = sameDay(auctionStartDate, auctionEndDate);

      // if (!auctionDayDiff) {
      //   this.laddaLoading = false;
      //   return this.toastr.error(
      //     'Auction end-date can not be before start-date'
      //   );
      // }

      // const auctionTime = timesDiff(auctionStartTime, auctionEndTime);

      // if (isAuctionSameDay) {
      //   if (auctionTime.includes('-')) {
      //     this.laddaLoading = false;
      //     return this.toastr.error(
      //       'Please choose End time greater than Start time!'
      //     );
      //   }

      //   if (auctionTime === '00:00') {
      //     this.laddaLoading = false;
      //     return this.toastr.error(
      //       'Auction time diffrence should not be less than 1 minute'
      //     );
      //   }
      // }

      // Live Auction
      const liveAuctionStartDate = data['auction_end_date'];
      const liveAuctionEndDate = data['live_auction_end_date'];

      const liveAuctionStartTime = data['auction_end_time'];
      const liveAuctionEndTime = data['live_auction_end_time'];

      const liveAuctionDayDiff = daysDiff(
        liveAuctionStartDate,
        liveAuctionEndDate
      );
      const isAuctionLiveSameDay = sameDay(
        liveAuctionStartDate,
        liveAuctionEndDate
      );

      if (!liveAuctionDayDiff) {
        this.laddaLoading = false;
        return this.toastr.error(
          'Live auction end-date can not be before start-date'
        );
      }

      const liveAuctionTime = timesDiff(
        liveAuctionStartTime,
        liveAuctionEndTime
      );

      if (isAuctionLiveSameDay) {
        if (liveAuctionTime.includes('-')) {
          this.laddaLoading = false;
          return this.toastr.error(
            'Please choose End time greater than Start time!'
          );
        }

        if (liveAuctionTime === '00:00') {
          this.laddaLoading = false;
          return this.toastr.error(
            'Auction time diffrence should not be less than 1 minute'
          );
        }
      }

      this.live_auctionStartTime = dateAndTimeConverter(
        liveAuctionStartDate,
        liveAuctionStartTime
      );
      this.live_auctionEndTime = dateAndTimeConverter(
        liveAuctionEndDate,
        liveAuctionEndTime
      );

      // const biddingTimeInterval = parseInt(data['time_interval']);
      // const countDownTimer = parseInt(data['countdown_timer']);

      // if (biddingTimeInterval < countDownTimer) {
      //   this.laddaLoading = false;
      //   return this.toastr.error(
      //     'Bidding time interval should be greater than countdown timer'
      //   );
      // }

      const result = auctionPriceCheck(
        data['opening_price'],
        data['lowest_price_to_accept'],
        data['incremental_value'],
        data['buy_now_price']
      );

      if (result.status === false) {
        this.laddaLoading = false;
        return this.toastr.error(result.message);
      }

      if (
        this.auctionStartTime &&
        this.auctionEndTime &&
        this.live_auctionStartTime &&
        this.live_auctionEndTime
      ) {
        let all_data = {
          auction_id: '',
          auction_type: null,
          title: data['title'],
          entity_type: entityType,
          item: data['item1'],
          auction_start_date_time: this.auctionStartTime,
          auction_end_date_time: this.auctionEndTime,
          live_auction_start_date_time: this.live_auctionStartTime,
          live_auction_end_date_time: this.live_auctionEndTime,
          description: data['description'],
          opening_price: data['opening_price'],
          lowest_price: data['lowest_price_to_accept'],
          incremental_price: data['incremental_value'],
          buy_now_price: data['buy_now_price'],
          other_details: data['fields'],
          auto_bid_setup: 0,
          // countdown_timer: countDownTimer,
          // bidding_time_interval: biddingTimeInterval,
        };

        this.auctionFormData.push(all_data);

        this.editAuctionService(all_data, 'individual');
      } else {
        return false;
      }
    } else if (this.auctionId) {
      // const auctionStartDate = data['auction_start_date'];
      // const auctionEndDate = data['auction_end_date'];

      // const auctionStartTime = data['auction_start_time'];
      // const auctionEndTime = data['auction_end_time'];

      // this.auctionStartTime = dateAndTimeConverter(
      //   auctionStartDate,
      //   auctionStartTime
      // );
      // this.auctionEndTime = dateAndTimeConverter(
      //   auctionEndDate,
      //   auctionEndTime
      // );

      // const auctionDayDiff = daysDiff(auctionStartDate, auctionEndDate);
      // const isAuctionSameDay = sameDay(auctionStartDate, auctionEndDate);

      // if (!auctionDayDiff) {
      //   this.laddaLoading = false;
      //   return this.toastr.error(
      //     'Auction end-date can not be before start-date'
      //   );
      // }

      // const auctionTime = timesDiff(auctionStartTime, auctionEndTime);

      // if (isAuctionSameDay) {
      //   if (auctionTime.includes('-')) {
      //     this.laddaLoading = false;
      //     return this.toastr.error(
      //       'Please choose End time greater than Start time!'
      //     );
      //   }

      //   if (auctionTime === '00:00') {
      //     this.laddaLoading = false;
      //     return this.toastr.error(
      //       'Auction time diffrence should not be less than 1 minute'
      //     );
      //   }
      // }

      // Live
      const liveAuctionStartDate = data['auction_end_date'];
      const liveAuctionEndDate = data['live_auction_end_date'];

      const liveAuctionStartTime = data['auction_end_time'];
      const liveAuctionEndTime = data['live_auction_end_time'];

      const liveAuctionDayDiff = daysDiff(
        liveAuctionStartDate,
        liveAuctionEndDate
      );
      const isAuctionLiveSameDay = sameDay(
        liveAuctionStartDate,
        liveAuctionEndDate
      );

      if (!liveAuctionDayDiff) {
        this.laddaLoading = false;
        return this.toastr.error(
          'Live auction end-date can not be before start-date'
        );
      }

      const liveAuctionTime = timesDiff(
        liveAuctionStartTime,
        liveAuctionEndTime
      );

      if (isAuctionLiveSameDay) {
        if (liveAuctionTime.includes('-')) {
          this.laddaLoading = false;
          return this.toastr.error(
            'Please choose End time greater than Start time!'
          );
        }

        if (liveAuctionTime === '00:00') {
          this.laddaLoading = false;
          return this.toastr.error(
            'Auction time diffrence should not be less than 1 minute'
          );
        }
      }

      this.live_auctionStartTime = dateAndTimeConverter(
        data['auction_end_date'],
        data['auction_end_time']
      );
      this.live_auctionEndTime = dateAndTimeConverter(
        data['live_auction_end_date'],
        data['live_auction_end_time']
      );

      this.otherDetailsList = [];
      for (let [_, value] of Object.entries(data['fields'])) {
        this.otherDetailsList.push(value);
      }

      // let getBiddingTimeInterval_inSecond = parseFloat(
      //   this.timedAuctionForm.value['time_interval']
      // );
      // let getCountdownTimer = parseFloat(
      //   this.timedAuctionForm.value['countdown_timer']
      // );

      // if (getBiddingTimeInterval_inSecond > getCountdownTimer) {
      //   this.getBiddinfTimeInterval = getBiddingTimeInterval_inSecond;
      //   this.getCountdownTimer = this.timedAuctionForm.value['countdown_timer'];
      // } else {
      //   this.toastr.error(
      //     'Bidding time interval should be greater than countdown timer'
      //   );
      // }

      const result = auctionPriceCheck(
        data['opening_price'],
        data['lowest_price_to_accept'],
        data['incremental_value'],
        data['buy_now_price']
      );

      if (result.status === false) {
        this.laddaLoading = false;
        return this.toastr.error(result.message);
      }

      let all_data = {
        auction_id: this.auctionId,
        auction_type: null,
        title: data['title'],
        entity_type: entityType,
        item: data['item1'] || this.timedAuctionForm.get('item1').value,
        // auction_start_date_time: this.auctionStartTime,
        // auction_end_date_time: this.auctionEndTime,
        auction_start_date_time: convertDateFormat(
          data['auction_start_date_time']
        ),
        auction_end_date_time: this.live_auctionStartTime,
        live_auction_start_date_time: this.live_auctionStartTime,
        live_auction_end_date_time: this.live_auctionEndTime,
        description: data['description'],
        opening_price: data['opening_price'],
        lowest_price: data['lowest_price_to_accept'],
        incremental_price: data['incremental_value'],
        buy_now_price: data['buy_now_price'],
        other_details: this.otherDetailsList,
        auto_bid_setup: 0,
        countdown_timer: this.getCountdownTimer,
        bidding_time_interval: this.getBiddinfTimeInterval,
      };

      console.log(all_data, 'all_data');

      // // HERE
      // if (this.lockStatus && this.adminApprove === false) {
      this.editAuctionService(all_data, this.activeQuery);
      // } else {
      //   this.addAuctionService(all_data, this.activeQuery);
      // }
    }
  }

  // ===========================================

  getEditAuctionInfo() {
    this.loading = true;

    this.auctionService.getEditAuctionData(this.auctionId).subscribe(
      (res) => {
        this.productId = res['data']['product_id'];
        this.isActiveAuction = res['data']['active_time_status'];
        this.lockStatus = res['data']['lock_status'];
        this.adminApprove = res['data']?.['approval'];
        let data = res['data'];
        this.timedAuctionForm.get('title').setValue(data['title']);
        this.timedAuctionForm
          .get('opening_price')
          .setValue(data['opening_price']);
        this.timedAuctionForm
          .get('lowest_price_to_accept')
          .setValue(data['lowest_price']);
        this.timedAuctionForm
          .get('incremental_value')
          .setValue(data['incremental_price']);
        this.timedAuctionForm
          .get('buy_now_price')
          .setValue(data['buy_now_price']);

        // Set Auction Values

        let auction_start_dates = data['auction_start_date_time'].split(',')[0];
        let auction_start_times =
          data['auction_start_date_time'].split(',')[1].slice(1, 6) +
          data['auction_end_date_time'].split(',')[1].slice(9, 12);

        this.timedAuctionForm
          .get('auction_start_date')
          .setValue(auction_start_dates);
        this.timedAuctionForm
          .get('auction_start_time')
          .setValue(auction_start_times);

        let auction_end_dates = data['auction_end_date_time'].split(',')[0];
        let auction_end_times =
          data['auction_end_date_time'].split(',')[1].slice(1, 6) +
          data['auction_end_date_time'].split(',')[1].slice(9, 12);

        this.timedAuctionForm
          .get('auction_start_date_time')
          .setValue(data['auction_start_date_time']);

        this.timedAuctionForm
          .get('auction_end_date_time')
          .setValue(data['auction_end_date_time']);

        this.timedAuctionForm
          .get('auction_end_date')
          .setValue(auction_end_dates);
        this.timedAuctionForm
          .get('auction_end_time')
          .setValue(auction_end_times);

        // END

        if (
          data['auction_type'] !== '0' &&
          data['entity_type'] === 'timed-individual'
        ) {
          let description_data = data['description'];
          this.timedAuctionForm.get('description').setValue(description_data);
        }

        // Set Live Auction Values

        let live_auction_start_dates =
          data['live_auction_start_date_time'].split(',')[0];
        let live_auction_start_times =
          data['live_auction_start_date_time'].split(',')[1].slice(1, 6) +
          data['live_auction_start_date_time'].split(',')[1].slice(9, 12);

        this.timedAuctionForm
          .get('live_auction_start_date')
          .setValue(live_auction_start_dates);
        this.timedAuctionForm
          .get('live_auction_start_time')
          .setValue(live_auction_start_times);

        let live_auction_end_dates =
          data['live_auction_end_date_time'].split(',')[0];
        let live_auction_end_times =
          data['live_auction_end_date_time'].split(',')[1].slice(1, 6) +
          data['live_auction_end_date_time'].split(',')[1].slice(9, 12);

        this.timedAuctionForm
          .get('live_auction_end_date')
          .setValue(live_auction_end_dates);
        this.timedAuctionForm
          .get('live_auction_end_time')
          .setValue(live_auction_end_times);

        // this.timedAuctionForm
        //   .get('time_interval')
        //   .setValue(data['bidding_time_interval']);
        // this.timedAuctionForm
        //   .get('countdown_timer')
        //   .setValue(data['countdown_timer']);

        let item = `${data?.['description_data']?.['Model Year']} ${data?.['description_data']?.['Model']} ${data?.['description_data']?.['Interior Colour']} (${data?.['description_data']?.['VIN Number']})`;
        this.timedAuctionForm.get('item1').setValue(item);
        this.editId = data['product_id'];

        // END

        //Set Image
        this.getProductImages = [];
        if (data['imageUrl'] && !data['vehicle_images']) {
          for (let [_, images] of Object.entries(data['imageUrl'])) {
            this.getProductImages.push(images['presigned_url']);
          }
        } else if (data['vehicle_images'] && !data['imageUrl']) {
          for (let [_, images] of Object.entries(
            data['vehicle_images']['parts_images']
          )) {
            this.getProductImages.push(this.baseUrl + images['image']);
          }
        }
        //END

        // Set Others fields Values
        this.otherDetailsList = [];
        this.otherDetailsList = data['other_details'];

        for (let [_, value] of Object.entries(this.otherDetailsList)) {
          this.timeIndividualFormArray.push(
            this.formBuilder.group({
              entity_name: value['entity_name'],
              entity_value: value['entity_value'],
            })
          );
        }

        // END
        setTimeout(() => {
          this.loading = false;
        }, 250);
      },
      (error: HttpErrorResponse) => {
        if (error.error.message == 'The incoming token has expired') {
          this.router.navigate(['/']);
        } else {
          this.toastr.warning(error.statusText);
        }
      }
    );
  }

  // ============================================

  getAllBatchList() {
    this.batch.loading = true;

    const sub = this.inventoryService
      .fetchBatches(this.batch.page, this.batch.limit)
      .subscribe({
        next: (res) => {
          if (res?.['success']) {
            const newItems = res['data'] || [];
            this.batches = [...this.batches, ...newItems];
            this.batch.page = res?.['nextPage'];
            this.batch.loading = false;
          }
        },
        error: (error) => {
          this.batch.loading = false;
          console.error(error);
        },
      });

    this.subscription.add(sub);
  }

  onEndAuction() {
    this.endAuctionLoading = true;
    this.auctionService.endAuction(this.auctionId).subscribe(
      (res) => {
        this.toastr.success(res['message']);
        this.router.navigate([`dashboard/auction/timed-individual`], {
          queryParams: {
            tab: 'on-going',
            page: 1,
            limit: 10,
          },
        });
        this.endAuctionLoading = false;
      },
      (error: HttpErrorResponse) => {
        this.laddaLoading = false;
        console.log(error);
      }
    );
  }
}
